
define('ldsh!modules/form_editor/templates/editor_check_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="flex align-center gap-8">\n  <div class="md__checkbox--wrapper">\n    ';
 const id = 'select-option-' + itemId; ;
__p += '\n     <input\n      id="' +
((__t = ( id )) == null ? '' : __t) +
'"\n      type="checkbox"\n      class="md__checkbox--primary js-filter-hidden js-selected"\n      ' +
((__t = ( checked )) == null ? '' : __t) +
'\n    />\n    <label\n      for="' +
((__t = ( id )) == null ? '' : __t) +
'"\n    ></label>\n  </div>\n\n  <input type="text" class="ed-form-control js-text" value="' +
((__t = ( radioText )) == null ? '' : __t) +
'">\n  <span class="flex align-center gap-4">\n    <button\n      type="button"\n      class="btn--rounded btn--ghost js-toggle-value"\n      data-i18n="[title]formEditor.toolbar.editValue"\n    >\n      <span class="ri-code-s-slash-fill"></span>\n    </button>\n    <button\n      type="button"\n      class="btn--rounded btn--ghost js-add"\n      data-i18n="[title]formEditor.toolbar.addItem"\n    >\n      <span class="ri-add-line"></span>\n    </button>\n    <button\n      type="button"\n      class="btn--rounded btn--ghost js-remove"\n      data-i18n="[title]formEditor.toolbar.removeItem"\n    >\n      <span class="ri-delete-bin-6-line"></span>\n    </button>\n  </span>\n</div>\n<p class="ed-input-value ed-form-group-row hidden js-item-value">\n  <span class="ed-value-label" data-i18n="formEditor.dropDownItemValue">Valor</span>\n  <input type="text" value="' +
((__t = ( value )) == null ? '' : __t) +
'" class="ed-form-control js-value-text">\n</p>\n';
 if (renderItemRequired) { ;
__p += '\n  <div class="md__checkbox--wrapper ed-input-value ed-form-group-row hidden js-item-value">\n    <input\n      id="field-required"\n      type="checkbox"\n      class="md__checkbox--primary js-item-required"\n      ' +
((__t = ( (isItemRequired) ? 'checked': '' )) == null ? '' : __t) +
'\n    />\n    <label\n      for="field-required"\n      data-i18n="[text]formEditor.isRequired"\n    ></label>\n  </div>\n';
 } ;
__p += '\n\n';

}
return __p
};});

